const GlobalAlert = () =>{
    return(
        <div className="alert alert-light" role="alert">
            <div style={{color: "#b71234"}}>IMPORTANT NOTICE</div>
            <br/>
            <div style={{color: "#b71234"}}>Please be aware that the following courses will be updated Monday, November 23, 2026:</div>
            <br/>
            <ul style={{color: "#b71234"}}>
                <li>SafeSport® Trained Core</li>
                <li>Refreshers 1, 2, and 3</li>
            </ul>
            <br/>
            <div style={{color: "#b71234"}}>
                <div><strong><em>Please complete the in-progress course by Sunday, November 22 to avoid having progress reset and having to restart the course from the beginning.</em></strong></div>
            </div>
        </div>
    );
};

export default GlobalAlert;
